import React from "react";
import { Slide, Fade } from "react-awesome-reveal";
import LogoSmams       from "../../assets/img/Smams.png";
import LogoBilly        from "../../assets/img/BillyBrowns.png";
import LogoResiPrep     from "../../assets/img/ResiPrep.png";
import LogoCharanguitos from "../../assets/img/Charanguitos.png";
import LogoDormo        from "../../assets/img/Dormo.png";
import LogoPizza7       from "../../assets/img/Pizzasiete.png";
import "../../styles/ClientsStrip.css";

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */
const clients = [
  { name: "Smams",       logo: LogoSmams       },
  { name: "Billy Browns",logo: LogoBilly        },
  { name: "ResiPrep",    logo: LogoResiPrep     },
  { name: "Charanguitos",logo: LogoCharanguitos },
  { name: "Dormo",       logo: LogoDormo        },
  { name: "Pizza 7",     logo: LogoPizza7       },
];

/* Duplicamos el array para que el scroll infinito
   no deje huecos al dar la vuelta */
const track = [...clients, ...clients];

/* ─────────────────────────────────────────────
   COMPONENT
───────────────────────────────────────────── */
const ClientsStrip = () => (
  <section className="clients-section">
    <div className="container">

      {/* ── Header ── */}
      <Slide direction="up" duration={700} triggerOnce>
        <div className="clients-header">
          <span className="eco-badge">Track record</span>
          <h2 className="eco-main-title text-white mt-3">
            Empresas que ya trabajan con nosotros
          </h2>
          <p className="eco-main-sub text-white-50">
            Cada proyecto que entregamos deja un sistema funcionando,
            un equipo capacitado y datos reales que impulsan decisiones.
          </p>
        </div>
      </Slide>

    </div>

    {/* ── Infinite scroll strip (full-width, outside container) ── */}
    <Fade delay={300} duration={800} triggerOnce>
      <div className="clients-track-wrapper" aria-label="Clientes">
        <div className="clients-track">
          {track.map((c, i) => (
            <div className="clients-logo-slot" key={i}>
              <img
                src={c.logo}
                alt={c.name}
                className="clients-logo-img"
                draggable={false}
              />
            </div>
          ))}
        </div>
      </div>
    </Fade>

    {/* ── Soft trust line ── */}
    <Fade delay={500} duration={700} triggerOnce>
      <p className="clients-footnote">
        Proyectos de digitalización, automatización y desarrollo a medida
        — entregados y en producción.
      </p>
    </Fade>
  </section>
);

export default ClientsStrip;
